export type TowerKind = 'SOL' | 'ETH' | 'BTC'

export interface TowerDefinition {
  readonly kind: TowerKind
  readonly name: string
  readonly role: string
  readonly cost: number
  readonly range: number
  readonly damage: number
  readonly fireIntervalMs: number
  readonly projectileSpeed: number
  readonly color: number
  readonly cssColor: string
}

export const TOWER_DEFINITIONS: Record<TowerKind, TowerDefinition> = {
  SOL: {
    kind: 'SOL', name: 'SOL NODE', role: 'Rapid / swarm', cost: 600,
    range: 170, damage: 8, fireIntervalMs: 190, projectileSpeed: 620,
    color: 0x31f8c8, cssColor: '#31f8c8',
  },
  ETH: {
    kind: 'ETH', name: 'ETH VALIDATOR', role: 'Balanced', cost: 1200,
    range: 205, damage: 28, fireIntervalMs: 650, projectileSpeed: 500,
    color: 0x8c75ff, cssColor: '#8c75ff',
  },
  BTC: {
    kind: 'BTC', name: 'BTC MINER', role: 'Heavy / single target', cost: 2800,
    range: 240, damage: 110, fireIntervalMs: 1450, projectileSpeed: 330,
    color: 0xffa629, cssColor: '#ffa629',
  },
}

export const TOWER_KINDS = Object.keys(TOWER_DEFINITIONS) as TowerKind[]
